// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__2tVYK","active":"Category_active__3uZGC"};